module.exports = __webpack_public_path__ + "static/media/wi-moonset.18f91498.svg";